import posthog from 'posthog-js'
import type { PostHog } from 'posthog-js'
import { defineNuxtPlugin } from '#app'

/**
 * Every branch has to provide the same shape or the inferred return type is a
 * union of two different `provide` objects, which is not a valid plugin.
 */
interface PosthogProvide {
  provide: { posthog: () => PostHog | null }
}

export default defineNuxtPlugin((_nuxtApp): PosthogProvide => {
  // Skip in test environment
  if (process.env.VITEST === 'true' || process.env.NODE_ENV === 'test' || process.env.TEST === 'true') {
    return {
      provide: {
        posthog: () => null,
      },
    }
  }

  const runtimeConfig = useRuntimeConfig()

  // Disable PostHog on localhost
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    return {
      provide: {
        posthog: () => null,
      },
    }
  }

  const posthogClient = posthog.init(runtimeConfig.public.posthogPublicKey, {
    api_host: runtimeConfig.public.posthogHost,
    person_profiles: 'identified_only',
    disable_session_recording: true,
    loaded: (posthog) => {
      if (import.meta.env.MODE === 'development') posthog.debug()
    },
  })

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
